// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
/* Header container */
/* .header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  justify-content: space-between; 
}
.breadcrumb-container {
    flex-grow: 1; 
} */
.header-container {
  /* display: flex;
  align-items: center;
  justify-content: center;
  position: relative; 
  width: 100%;
  justify-content: space-between; */
}

/* Breadcrumb container: Prevents it from affecting title positioning */
.breadcrumb-container {
  display: flex;
  align-items: center;
  gap: 8px; /* Adds spacing between breadcrumb items */
  font-size: 14px;
  font-weight: 500;
}

.breadcrumb-container a {
  color: #007bff; /* Blue for links */
  text-decoration: none;
  transition: color 0.3s ease-in-out;
}

.breadcrumb-container a:hover {
  color: #0056b3; /* Darker blue on hover */
  text-decoration: underline;
}

.breadcrumb-container .current-page {
  color: #333; /* Dark gray for the current page */
  font-weight: bold;
}

/* Dashboard Title: Always centered */
.dashboard-title {
  /* position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap; */
}


.back-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  /* position: absolute; */
  /* left: 0; */
  padding-left: 8px;
  color: #0070E9;
  font-weight: bold;
}

.dashboard-title {
  color: #0070E9;
}

.back-button span {
  color: #0070E9;
  margin-left: 5px;
  font-size: 16px;
}

.back-button img {
  filter: brightness(0) saturate(100%) invert(23%) sepia(92%) saturate(3484%) hue-rotate(210deg) brightness(95%) contrast(108%);
}

.dashboard-title {
  text-align: center;
  flex-grow: 1;
  margin: 0px;
  padding-bottom: 20px;
}

.quality-dashboard {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 20px;
  background-color: #f4f6f9;
  font-family: "Arial", sans-serif;
  padding-bottom: 60px;
}

.dashboard-content {
  flex-grow: 1;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}


.filters-container {
  background: #fff;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

}


/* .filters-box {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
} */

.filter-item {
  flex: 1 1;
  min-width: 180px;
  max-width: 220px;
}

.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-buttons .MuiButton-containedPrimary {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white !important;
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.filter-buttons .MuiButton-containedPrimary:hover {
  background: linear-gradient(135deg, #0056b3, #003d80);
} 






/* Responsive: Smaller screens (tablets and phones) */
@media (max-width: 768px) {
  .filters-container {
    border-radius: 0;
    padding: 10px 12px;
  }

  .filters-box {
    grid-template-columns: 1fr;
  }
}




/* Quality Detail View */
.quality-view-main {
  min-height: 100vh;
  padding: 0px 20px 20px 20px;
  background-color: #f4f6f9;
  font-family: "Inter"
}

.custom-table {
  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
}

.custom-table-head {
  background: #ababab;
  box-shadow: 20px 20px 60px #c9c9c9, -20px -20px 60px #ffffff;
}

.custom-table-body {
background: #ffffff;
box-shadow: inset 20px 20px 60px #d9d9d9,
            inset -20px -20px 60px #ffffff;
}

.final-report-text p {
margin: 0px;
}

.update-btn .MuiButton-containedPrimary {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white !important;
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
}

.update-btn .MuiButton-containedPrimary:hover {
  background: linear-gradient(135deg, #0056b3, #003d80);
  font-family: "Inter";
  text-transform: capitalize;
}

.custom-table2-head {
  background: #86929c;
  box-shadow: 20px 20px 60px #c9c9c9, -20px -20px 60px #ffffff;
}

.quality-view-header {
  padding: 20px 0px;
  font-size: 18px;
  font-weight: 500;
  color: brown;
}

.quality-view-accession-details {
  line-height: 2.5;
}

.quality-view-success {
  background: green;
  border-radius: 15px;
  padding: 2px 20px;
  font-weight: 500;
  color: white;
}

.quality-view-failed {
  background: red;
  border-radius: 15px;
  padding: 2px 20px;
  font-weight: 500;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/views/panel/vraShifts/QualityDashboard/qualityDashboard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,qBAAqB;AACrB;;;;;;;;;;GAUG;AACH;EACE;;;;;mCAKiC;AACnC;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,0CAA0C;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc,EAAE,yBAAyB;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE;;;wBAGsB;AACxB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6HAA6H;AAC/H;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;;AAE7C;;;AAGA;;;;;;GAMG;;AAEH;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;;;;;;AAOA,qDAAqD;AACrD;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;;;AAKA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;AACA,mBAAmB;AACnB;0CAC0C;AAC1C;;AAEA;AACA,WAAW;AACX;;AAEA;EACE,qDAAqD;EACrD,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/* Main Container */\n/* Header container */\n/* .header-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  justify-content: space-between; \n}\n.breadcrumb-container {\n    flex-grow: 1; \n} */\n.header-container {\n  /* display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative; \n  width: 100%;\n  justify-content: space-between; */\n}\n\n/* Breadcrumb container: Prevents it from affecting title positioning */\n.breadcrumb-container {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* Adds spacing between breadcrumb items */\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.breadcrumb-container a {\n  color: #007bff; /* Blue for links */\n  text-decoration: none;\n  transition: color 0.3s ease-in-out;\n}\n\n.breadcrumb-container a:hover {\n  color: #0056b3; /* Darker blue on hover */\n  text-decoration: underline;\n}\n\n.breadcrumb-container .current-page {\n  color: #333; /* Dark gray for the current page */\n  font-weight: bold;\n}\n\n/* Dashboard Title: Always centered */\n.dashboard-title {\n  /* position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap; */\n}\n\n\n.back-button {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  /* position: absolute; */\n  /* left: 0; */\n  padding-left: 8px;\n  color: #0070E9;\n  font-weight: bold;\n}\n\n.dashboard-title {\n  color: #0070E9;\n}\n\n.back-button span {\n  color: #0070E9;\n  margin-left: 5px;\n  font-size: 16px;\n}\n\n.back-button img {\n  filter: brightness(0) saturate(100%) invert(23%) sepia(92%) saturate(3484%) hue-rotate(210deg) brightness(95%) contrast(108%);\n}\n\n.dashboard-title {\n  text-align: center;\n  flex-grow: 1;\n  margin: 0px;\n  padding-bottom: 20px;\n}\n\n.quality-dashboard {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #f4f6f9;\n  font-family: \"Arial\", sans-serif;\n  padding-bottom: 60px;\n}\n\n.dashboard-content {\n  flex-grow: 1;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n}\n\n\n.filters-container {\n  background: #fff;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n\n}\n\n\n/* .filters-box {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n} */\n\n.filter-item {\n  flex: 1;\n  min-width: 180px;\n  max-width: 220px;\n}\n\n.filter-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.filter-buttons .MuiButton-containedPrimary {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white !important;\n  font-weight: bold;\n  padding: 10px 15px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.filter-buttons .MuiButton-containedPrimary:hover {\n  background: linear-gradient(135deg, #0056b3, #003d80);\n} \n\n\n\n\n\n\n/* Responsive: Smaller screens (tablets and phones) */\n@media (max-width: 768px) {\n  .filters-container {\n    border-radius: 0;\n    padding: 10px 12px;\n  }\n\n  .filters-box {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n\n\n/* Quality Detail View */\n.quality-view-main {\n  min-height: 100vh;\n  padding: 0px 20px 20px 20px;\n  background-color: #f4f6f9;\n  font-family: \"Inter\"\n}\n\n.custom-table {\n  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);\n}\n\n.custom-table-head {\n  background: #ababab;\n  box-shadow: 20px 20px 60px #c9c9c9, -20px -20px 60px #ffffff;\n}\n\n.custom-table-body {\nbackground: #ffffff;\nbox-shadow: inset 20px 20px 60px #d9d9d9,\n            inset -20px -20px 60px #ffffff;\n}\n\n.final-report-text p {\nmargin: 0px;\n}\n\n.update-btn .MuiButton-containedPrimary {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white !important;\n  font-weight: bold;\n  padding: 10px 15px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n}\n\n.update-btn .MuiButton-containedPrimary:hover {\n  background: linear-gradient(135deg, #0056b3, #003d80);\n  font-family: \"Inter\";\n  text-transform: capitalize;\n}\n\n.custom-table2-head {\n  background: #86929c;\n  box-shadow: 20px 20px 60px #c9c9c9, -20px -20px 60px #ffffff;\n}\n\n.quality-view-header {\n  padding: 20px 0px;\n  font-size: 18px;\n  font-weight: 500;\n  color: brown;\n}\n\n.quality-view-accession-details {\n  line-height: 2.5;\n}\n\n.quality-view-success {\n  background: green;\n  border-radius: 15px;\n  padding: 2px 20px;\n  font-weight: 500;\n  color: white;\n}\n\n.quality-view-failed {\n  background: red;\n  border-radius: 15px;\n  padding: 2px 20px;\n  font-weight: 500;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
